export default __webpack_public_path__ + "static/media/AskMeLogoAltThin.4f920206.jp2";